import React from "react";
import { useStore } from "react-redux";
import MyRouter from "routers/index";
import setUpInterceptor from "app/axios.interceptor";

function App() {
  const store = useStore();
  setUpInterceptor(store);

  const handleSkipToContent = (e: React.MouseEvent<HTMLAnchorElement>) => {
    const target = document.getElementById("main-content");
    if (target) {
      target.focus();
      target.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div className="min-h-screen bg-white text-base dark:bg-neutral-900 text-neutral-900 dark:text-neutral-200">
      <a
        href="#main-content"
        onClick={handleSkipToContent}
        className="skip-link sr-only focus:not-sr-only focus:fixed focus:top-4 focus:left-4 focus:z-[9999] focus:px-5 focus:py-2.5 focus:bg-primary-6000 focus:text-white focus:font-medium focus:rounded-md focus:shadow-2xl focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-6000 dark:focus:ring-offset-neutral-900"
      >
        Skip to main content
      </a>
      <MyRouter />
    </div>
  );
}

export default App;
